export default __webpack_public_path__ + "static/media/coin_bch.cfb20572.svg";